import { css } from "@emotion/css";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
interface ResizeColumnHandleProps {
    isActive: boolean;
}
export function ResizeColumnHandle({ isActive }: ResizeColumnHandleProps) {
    return (<div className={resizeColumnStyles.dragHandlePositioningContainer}>
            <div className={resizeColumnStyles.dragHandleDraggableArea}>
                <div className={`${resizeColumnStyles.dragHandleIndicator} ${isActive ? resizeColumnStyles.dragHandleIndicatorDark : resizeColumnStyles.dragHandleIndicatorLight}`}/>
            </div>
        </div>);
}
const resizeColumnStyles = {
    dragHandlePositioningContainer: css({
        position: "relative",
        width: 0,
        height: "100%",
    }),
    dragHandleDraggableArea: css({
        position: "absolute",
        top: "0.25rem",
        bottom: "0.25rem",
        left: "-0.5rem",
        width: "1rem",
        cursor: "col-resize",
        display: "flex",
        justifyContent: "center",
    }),
    dragHandleIndicator: css({
        width: "0.0625rem",
    }),
    dragHandleIndicatorLight: css({
        backgroundColor: themeTokens.color.border.tertiary,
    }),
    dragHandleIndicatorDark: css({
        backgroundColor: themeTokens.color.border.link.default,
    }),
};
